export default __webpack_public_path__ + "static/2-cd857d6f761cee161b98670a3158c7fe.png";